import axiosInstance from '../utils/axiosConfig';
import { PurchaseOrder, ExpectedInvoice } from '../types/PurchaseOrder';

export const purchaseOrderService = {
  // Create a new purchase order
  async createPurchaseOrder(data: {
    performanceId: string;
    expectedInvoices: ExpectedInvoice[];
    budgetCategories: string[];
    imcCode?: string;
    notes?: string;
    emailToMonday?: boolean;
    poNumber?: string; // Add this

  }): Promise<PurchaseOrder> {
    const response = await axiosInstance.post('/api/purchase-orders', data);
    return response.data;
  },
  
  // Get all purchase orders
  async getPurchaseOrders(params?: {
    status?: string;
    performanceId?: string;
    startDate?: string;
    endDate?: string;
  }): Promise<PurchaseOrder[]> {
    const response = await axiosInstance.get('/api/purchase-orders', { params });
    return response.data;
  },
  
  // Get a purchase order by ID
  async getPurchaseOrderById(id: string): Promise<PurchaseOrder> {
    const response = await axiosInstance.get(`/api/purchase-orders/${id}`);
    return response.data;
  },
  
  // Get purchase orders for a performance
  async getPurchaseOrdersByPerformance(performanceId: string): Promise<PurchaseOrder[]> {
    const response = await axiosInstance.get(`/api/purchase-orders/performance/${performanceId}`);
    return response.data;
  },
updatePurchaseOrder: async (id: string, data: any) => {
  const response = await axiosInstance.put(`/api/purchase-orders/${id}`, data);
  return response.data;
},
  
  // Update purchase order status
  async updatePurchaseOrderStatus(id: string, status: string): Promise<PurchaseOrder> {
    const response = await axiosInstance.patch(`/api/purchase-orders/${id}/status`, { status });
    return response.data;
  },
  
  // Record invoice
  async recordInvoice(poId: string, data: {
    invoiceIndex: number;
    invoiceNumber: string;
    invoiceDate: Date;
    receiptDate: Date;
    notes?: string;
  }): Promise<PurchaseOrder> {
    const response = await axiosInstance.post(`/api/purchase-orders/${poId}/invoice`, data);
    return response.data;
  },
  
  // Record payment
  async recordPayment(poId: string, data: {
    invoiceIndex: number;
    paymentDate: Date;
    notes?: string;
  }): Promise<PurchaseOrder> {
    const response = await axiosInstance.post(`/api/purchase-orders/${poId}/payment`, data);
    return response.data;
  },
  
  // Email purchase order to Monday.com
  async emailPurchaseOrder(id: string): Promise<{ message: string }> {
    const response = await axiosInstance.post(`/api/purchase-orders/${id}/email`);
    return response.data;
  }
};